import { PagePaginationParams } from "@/model";
import { Module } from "vuex";

export type StateT = {
  pageParams: PagePaginationParams;
};

const LeadsView: Module<StateT, any> = {
  state: {
    pageParams: {
      pageNO: 1,
      pageSize: 10,
    },
  },
  mutations: {
    setPageParams(state, pageParams: PagePaginationParams) {
      state.pageParams = pageParams;
      console.log("state.pageParams :>> ", state.pageParams);
    },
  },
  actions: {},
  modules: {},
};

export default LeadsView;
